// Small, shared helpers for the initials-avatar-circle pattern used across
// the Forms Workspace (Build tab cards, Assign & Track table). Purely
// presentational -- derives a stable color/initials from a real display
// name already present in the row data, never fabricates identity.
const AVATAR_PALETTE = ["#4f46e5", "#0ea5e9", "#f59e0b", "#10b981", "#ec4899", "#7c3aed"];

export function initialsOf(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

export function avatarColorFor(name) {
  let hash = 0;
  for (let i = 0; i < (name || "").length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
}
